// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';
import { media } from '../../../../helpers';

type Props = {|
  engine: string,
  power?: string,
  fueltype?: string,
  className?: string,
|};

const Specs = ({
  engine,
  power,
  fueltype,
  className,
}: Props) => (
  <h2 className={className}>
    {engine}
    {' '}
    {power}
    {' '}
    {fueltype}
  </h2>
);

Specs.defaultProps = {
  power: '',
  fueltype: '',
  className: '',
};

export default styled<typeof Specs, Theme>(Specs)`
  color: ${props => props.theme.carblock.color};
  font-size: ${props => props.theme.carblock.specs.fontSize.default};
  line-height: 1.2em;
  margin: 0.3em 0 0 0;
  font-weight: ${props => props.theme.carblock.specs.fontWeight};

  ${media.lg(css`
    font-size: ${props => props.theme.carblock.specs.fontSize.lg};
  `)}
`;
